import { Card } from '@repo/shadcn';

import { DataTable } from '@components/ui/data.table/data-table';
import { SectionError } from '@components/ui/error';
import { SectionLoader } from '@components/ui/loader';
import PaginationComponent from '@components/ui/pagination';

import { HeaderBreadcrumb, SectionTitle } from '@/components/ui';
import { DEFAULT_PAGE_LIMIT, Route } from '@/constants';
import { useUrlPagination } from '@/hooks';

import { transactionsReportColumns } from './transactions.column';
import { useTransactionsReport } from './transactions.hook';

export const ReportTransaction = () => {
    const { page, setCurrentPage } = useUrlPagination();
    const { error, data, isError, isFetching, isLoading } =
        useTransactionsReport();

    if (isLoading) {
        return <SectionLoader />;
    }

    if (isError) {
        return <SectionError error={error} fallbackPath={Route.DASHBOARD} />;
    }

    const renderTable = () => {
        if (isError) {
            return <div>Something went wrong</div>;
        }

        return (
            <>
                <DataTable
                    isLoading={isLoading || isFetching}
                    data={data?.data || []}
                    columns={transactionsReportColumns}
                />
                <p className="mt-3 flex w-full items-center px-4 text-right font-semibold">
                    Total Found : {data?.pagination?.total_items}
                </p>
                <PaginationComponent
                    showTotalItems
                    totalItems={data?.pagination?.total_items || 0}
                    itemsPerPage={data?.pagination?.limit || DEFAULT_PAGE_LIMIT}
                    initialPage={page}
                    onPageChange={(p) => {
                        setCurrentPage(p);
                    }}
                />
            </>
        );
    };

    return (
        <Card className={'space-y-4 p-4'}>
            <HeaderBreadcrumb
                showHomeLink={true}
                items={[
                    {
                        label: 'Reports',
                    },
                    {
                        label: 'Transactions',
                    },
                ]}
            />

            <SectionTitle>All Transactions</SectionTitle>

            {renderTable()}
        </Card>
    );
};

ReportTransaction.displayName = 'ReportTransaction';
